import React from "react";
import { Modal, Button } from "react-bootstrap";

const BookingConfirmationModal = ({ show, onClose, overlapError }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Booking Conflict</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{overlapError}</p>
        <p>Please select a different time slot or date.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default BookingConfirmationModal;
